//@ts-nocheck
import React, { useEffect, useState } from "react";

import {
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { classNames } from "../../utils/classNames";
import { useNavigate, useSearchParams } from "react-router-dom";
import DownloadIcon from "../../Icons/DownloadIcon";
import UploadIcon from "../../Icons/UploadIcon";
import moment from "moment";

interface IDataTable {
  data: any;
  columns: any;
  tableName: string;
  actionMenu?: any;
  isUpload?: boolean
  isDownload?: boolean
}

function DataTable(props: IDataTable) {
  const { data, columns, actionMenu, isUpload = false, isDownload = false } = props;
  const [searchParams, setSearchParms] = useSearchParams({
    "limit": "10",
    "page": "0",
    "searchQuery": "",
  })
  const [limit, setLimit] = useState(10);
  // @ts-ignore
  const page: any = parseInt(searchParams.get("page"));
  const navigate = useNavigate();

  const table = useReactTable({
    data,
    columns,
    enableRowSelection: true,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });



  useEffect(() => {
    table.setPageSize(500);
  }, [limit]);

  const handleNextPage = () => {
    // searchParams.set("page", page + 1);
    // setSearchParms(searchParams);
  };

  const handlePreviousPage = () => {
    // searchParams.set("page", page - 1);
    // setSearchParms(searchParams);
  };

  const handleLastpage = () => {
    // searchParams.set("page", Math.floor(serverData?.count / limit));
    // setSearchParms(searchParams);
  };

  const handleFirstPage = () => {
    // searchParams.set("page", 0);
    // setSearchParms(searchParams);
  };

  const handleSearch = (value: string) => {
    // searchParams.set("searchQuery", value,);
    // searchParams.set("page", 0,);
    // setSearchParms(searchParams);
  }

  const handleDownloadExcel = async () => {
    try {
      // await downloadApiData(`${url}download-excel/`, `${queryKey}-${moment().format('MMMM-Do-YYYY-h-mm-ss')}.xlsx`)
    } catch (e) {
      console.log(e)
    }
  };

  const handleUploadExcel = () => {
    navigate("bulk-upload")
  }

  const getCellColor = (header: any) => {
    const myMomentObject = moment(header, 'YYYY-MM-DD')
    if (myMomentObject.day() === 6) {
      return "bg-red-600 text-white";
    } else {
      return ""
    }
  }
  const getDayName = (header: any) => {
    const myMomentObject = moment(header, 'YYYY-MM-DD')
    try {
      const value = myMomentObject.format('dddd');
      if (value === "Invalid date" || value === "Rider Name") {
        return ""
      }
      return value
    } catch (error) {
      return ""
    }
  }

  return (
    <>
      <div
        className="w-full bg-white rounded-sm mb-8"
        style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      >
        <div className="w-full grid grid-cols-1 gap-4 md:flex justify-between p-4">
          <div>
            <input
              type="text"
              placeholder="Search"
              onChange={(e) => handleSearch(e?.target?.value)}
              className="border w-full border-1 border-primary focus:outline-none p-1"
            />
          </div>
          <div className="text-primary w-full justify-end flex gap-x-4">
            <span
              className="flex gap-x-1 w-full cursor-pointer"
            >
              {actionMenu}
            </span>
            {isDownload &&
              <span
                className="flex gap-x-1 cursor-pointer"
                onClick={handleDownloadExcel}
              >
                <DownloadIcon color={"var(--primary)"} />
                Download
              </span>
            }
            {isUpload &&
              <span
                className="flex gap-x-1 cursor-pointer"
                onClick={handleUploadExcel}
              >
                <UploadIcon color={"var(--primary)"} />
                Upload
              </span>
            }
          </div>
        </div>
        <div className="w-full overflow-auto">
          <table className="w-full">
            <thead className="bg-primary text-white uppercase">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id} className="">
                  {headerGroup.headers.map((header, index) => (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      className={classNames(
                        index === 0
                          ? ""
                          : headerGroup.headers?.length - 1 === index
                            ? " text-left w-[8rem]"
                            : "",
                        "py-[5px] text-left px-5 whitespace-nowrap text-center"
                      )}
                    >
                      <span className="block">
                        {header.isPlaceholder
                          ? null
                          : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                      </span>
                      <span className="block">
                        {getDayName(header.column.columnDef?.header)}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr
                  key={row.id}
                  className="even:bg-gray-50 odd:bg-white hover:bg-gray-100 hover:transition-all"
                >
                  {row.getVisibleCells().map((cell) => (
                    <td title={cell.getContext()?.row?.original?.rider_name} key={cell.id} className={classNames(getCellColor(cell.column.columnDef?.header) ? getCellColor(cell.column.columnDef?.header) : "", "py-[10px] text-left px-5")}>
                      <>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
            <tfoot>
              {table.getFooterGroups().map((footerGroup) => (
                <tr key={footerGroup.id}>
                  {footerGroup.headers.map((header) => (
                    <th key={header.id} colSpan={header.colSpan}>
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                          header.column.columnDef.footer,
                          header.getContext()
                        )}
                    </th>
                  ))}
                </tr>
              ))}
            </tfoot>
          </table>
        </div>
        <div className="flex bg-white py-2 my-4 w-full justify-center gap-4">
          <button
            className="border hidden md:block rounded p-1"
            onClick={() => handleFirstPage()}
            disabled={true}
          >
            {"<<"}
          </button>
          <button
            className="border rounded p-1"
            onClick={() => handlePreviousPage()}
            disabled={true}
          >
            {"<"}
          </button>
          <button
            className="border rounded p-1"
            onClick={() => handleNextPage()}
            disabled={true}
          >
            {">"}
          </button>
          <button
            className="border hidden md:block rounded p-1"
            onClick={() => handleLastpage()}
            disabled={true}
          >
            {">>"}
          </button>
          <select
            value={table.getState().pagination.pageSize}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              searchParams.set("limit", e?.target?.value,);
              setSearchParms(searchParams)

            }}
          >
            {[10, 50, 100, 200, 500].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
          <p className="mt-1">All: {data?.count}</p>
        </div>
      </div>
    </>
  );
}

export default DataTable;
